"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SttFormControlLabel;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _defineProperty({}, theme.breakpoints.up("sm"), {
      marginBottom: "-5px"
    })
  };
});
function SttFormControlLabel(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], _extends({}, props, {
    className: classes.root
  }));
}